export default function Contact() {
  return (
    <section id="contact" className="scroll-mt-20 bg-navy-950 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime-400">Contact</p>
            <h2 className="mt-4 font-heading text-3xl font-black leading-tight text-white md:text-5xl">
              その公開予定日、
              <br />
              まずは聞かせてください。
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-navy-200">
              何のサイトを、いつまでに公開したいか。
              まだ内容が固まっていない段階でも、ご相談いただけます。
            </p>
          </div>

          <div className="rounded-lg border border-navy-800 bg-navy-900 p-6 md:p-8">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy-800 text-lime-400">
                <i className="ri-mail-line text-xl" aria-hidden="true" />
              </span>
              <div>
                <p className="font-heading text-base font-bold text-white">
                  お問い合わせ窓口は準備中です
                </p>
                <p className="mt-1 text-sm text-navy-300">
                  相談窓口は順次ご案内いたします。もうしばらくお待ちください。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}